import { RouterLinkProvider } from "@repo/ui/Link/routerLink";
import type { FC } from "react";
import type { DataRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { TeammateAuthorizationProvider } from "../helpers/teammateAuthorizationContext.js";
import { renderRouterAnchor } from "./routerAnchor.js";

export interface AdminRouterProviderProps {
  router: DataRouter;
}

/**
 * The shared provider boundary around an authenticated Admin router. Keeping
 * this outside the auth bootstrap lets production and browser tests render the
 * same route/provider composition with different router implementations.
 */
export const AdminRouterProvider: FC<AdminRouterProviderProps> = (props) => {
  const { router } = props;

  return (
    <TeammateAuthorizationProvider>
      <RouterLinkProvider render={renderRouterAnchor}>
        <RouterProvider router={router} />
      </RouterLinkProvider>
    </TeammateAuthorizationProvider>
  );
};
